import {Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {safeText} from '../../../utils';

const Description = ({description, style}) => {
  return (
    <Layout style={style}>
      <Text>{safeText(description)}</Text>
    </Layout>
  );
};

export default Description;
